import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { ResponseData } from '@/api/types'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000000
})

service.interceptors.request.use(
  (config) => {
    responseType: config.responseType
    if (config.headers['Content-Type'] === undefined) {
      config.headers['Content-Type'] = 'application/json'
    }
    if (UserModule.token) {
      config.headers['PZ-Token'] = UserModule.token
    }

    // ##服务器分流种类
    config.headers['canary'] = 2
    if (config.headers['Content-Type'] === 'application/json') {
      config.transformRequest = [
        function (data) {
          const requestBody = JSON.stringify({
            timestamp: new Date().getTime(),
            sign: 'nosign',
            data: data
          })
          return requestBody
        }
      ]
    }
    return config
  },
  (error) => {
    debugger
    console.log(error)
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  // (response):Promise<ResponseData> => {
  (response) => {
    const res = response.data
    if (res.code === undefined) {
      return response
    }

    // console.log(res.code <= 9010 && res.code >= 9000, res.code, 'code')
    if (res.code !== 0) {
      Message({
        message: res.msg.includes('No provider') ? '系统异常' : (res.msg || 'Error'),
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // UserModule.ResetToken()
        MessageBox.confirm(
          '你已被登出，可以取消继续留在该页面，或者重新登录',
          '确定登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          UserModule.ResetToken()
          location.reload() // To prevent bugs from vue-router
        })
      }
      console.log(res.msg)

      return Promise.reject(res.msg || 'Error')
    }  else {
      return response.data
    }
  },
  (error): Promise<ResponseData> => {
    
    // (error.response.data.code <= 9010 && error.response.data.code >= 9000)
    if (error.response.data.msg.includes('用户已登出') || error.response.data.msg.includes('缺失Token信息') || error.response.data.code === 401) {
      // UserModule.ResetToken()
      MessageBox.confirm(
        '你已被登出，可以取消继续留在该页面，或者重新登录',
        '确定登出',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        UserModule.ResetToken()
        location.reload()
      })
    } else {
      Message({
        message: error.response.data.msg,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
